import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchCategories = async () => {
  const res = await axios.get(`${API_URL}/productsCategories`, header());
  return res.data;
};

export const fetchCategory = async (id) => {
  const res = await axios.get(`${API_URL}/productsCategories/${id}`, header());
  return res.data;
};

export const createCategory = async (data) => {
  const res = await axios.post(`${API_URL}/productsCategories`, data, header());
  return res.data;
};

export const updateCategory = async (id, data) => {
  const res = await axios.put(`${API_URL}/productsCategories/${id}`, data, header());
  return res.data;
};

export const deleteCategory = async (id) => {
  await axios.delete(`${API_URL}/productsCategories/${id}`, header());
};

export default {
  fetchCategories,
  fetchCategory,
  createCategory,
  updateCategory,
  deleteCategory,
};
